import { SessionStore } from '../../constants/sessionStore';
import { BasicDetails } from '../../store/interfaces';
import { initialState } from '../../store/storeApi';

/** Method to fetch data from sessionStorage if present */
const fetchBasicDetailsFromStorage = (): BasicDetails => {
  const candidate = sessionStorage.getItem(SessionStore.candidate);
  const currentWorkflowItem = sessionStorage.getItem(SessionStore.currentWorkflowItem);
  const template = sessionStorage.getItem(SessionStore.template);
  const userSessionActive = sessionStorage.getItem(SessionStore.userSessionActive);

  const basicDetails: BasicDetails = initialState;
  if (currentWorkflowItem && template && userSessionActive) {
    try {
      basicDetails.currentWorkflowItem = JSON.parse(currentWorkflowItem);
      basicDetails.template = JSON.parse(template);
      basicDetails.userSessionActive = JSON.parse(userSessionActive);
      if (candidate) basicDetails.candidate = JSON.parse(candidate);
    } catch (error) {
      console.error('SessionStorage parse error: ', error);
    }
  }
  return basicDetails;
};

export default fetchBasicDetailsFromStorage;
